export const TagNames = {
  Checkout: 'Checkout',
  AddToCart: 'AddToCart',
  PageVisit: 'PageVisit',
};
